import { type StateCreator, create } from "zustand";

type User = {
	id: string;
	username: string;
	firstName?: string;
	lastName?: string;
};

interface UserStore {
	user: User | null;
	setUser: (user: User | null) => void;
}

export const useUserStore = create<UserStore>(((set) => ({
	user: null,
	setUser: (user: User | null) => set({ user }),
})) as StateCreator<UserStore>);
